module.exports = __webpack_public_path__ + "img/ic_dropdown_active.48a96b56.svg";